var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto"},[_c('spinner',{attrs:{"large":"","center":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }